import { shape, string, number } from '@thd-nucleus/data-sources';

export const redeemPerksModel = {
  perkSourceUUID: string(),
  giftCard: {
    availableBalance: number(),
    barCode: string(),
    pin: string(),
  }
};
